import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";

let isMounted = false;

export default withAuth(
  class SuperAdmin extends Component {
    constructor(props) {
      super(props);
      this.state = {
        ipLog: {}
      };

      this.purgeLAN = this.purgeLAN.bind(this);
      this.remakeSeats = this.remakeSeats.bind(this);
      this.createDevCopy = this.createDevCopy.bind(this);
      this.getVisitorLog = this.getVisitorLog.bind(this);
      this.startLogRefresh = this.startLogRefresh.bind(this);
      this.restoreBackup = this.restoreBackup.bind(this);
    }

    async componentDidMount() {
      isMounted = true;
      this.getVisitorLog();
      this.startLogRefresh();
    }

    componentWillMount() {}
    componentDidUpdate() {
      // Authentication is now handled by WithAuth HOC
    }

    componentWillUnmount() {
      clearInterval(this.interval);
      isMounted = false;
    }

    async startLogRefresh() {
      this.interval = setInterval(() => this.getVisitorLog(), 60000);
    }

    async purgeLAN() {
      if (
        window.confirm(
          "Dette vil fjerne all brukerdata fra produksjonsdatabasen, og gjøre alt klart til nytt LAN"
        )
      ) {
        //continue
      } else {
        return;
      }

      if (window.confirm("Er du helt sikker?")) {
        //continue
      } else {
        return;
      }
      const password = prompt("Tast inn passord", "passord");
      if (password.length === 0) {
        return;
      } else {
        try {
          await authenticatedFetch("/api/superAdmin/purgeLAN" + password, {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }).then(response => {

          });
        } catch (err) {
          console.log(err);
        } finally {
        }
      }
    }

    async restoreBackup() {
      if (
        window.confirm(
          "Dette vil fjerne all brukerdata fra produksjonsdatabasen og gjenopprette fra en backup"
        )
      ) {
        //continue
      } else {
        return;
      }

      if (window.confirm("Er du helt sikker?")) {
        //continue
      } else {
        return;
      }
      const password = await prompt("Tast inn passord", "passord");
      if (password.length === 0) {
        return null;
      } else {
        try {
          await authenticatedFetch("/api/superAdmin/restoreFromBackup" + password, {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }).then(response => {
            if (response.status === 200) {
              alert("Backup gjenopprettet");
            }
          });
        } catch (err) {
          console.log(err);
        } finally {
        }
      }
    }

    async remakeSeats() {
      try {
        await fetch("/api/seating/remakeSeats", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }).then(() => {
          alert(
            "Plassene er nå satt opp på nytt"
          );
        });
      } catch (err) {
        console.log(err);
      } finally {
      }
    }

    async createDevCopy() {
      if (
        window.confirm(
          "Dette vil slette den eksisterende dev-kopien. Er du helt sikker?"
        )
      ) {
        //continue
      } else {
        return;
      }

      try {
        await authenticatedFetch("/api/superAdmin/createDevCopy", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }).then(() => {
          window.alert("Kopiering var vellykket");
        });
      } catch (err) {
        console.log(err);
      } finally {
      }
    }

    async getVisitorLog() {
      if (isMounted === true) {
        try {
          await authenticatedFetch("/api/superAdmin/getVisitorLog", {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          })
            .then(response => {
              return response.json();
            })
            .then(ipLog => {
              this.setState({ ipLog: ipLog });
            });
        } catch (err) {
          console.log(err);
          return 'error getting visitorlog';
        } finally {
        }
      }
    }

    render() {
      const ipItems = [];
      if (this.state.ipLog.ipList !== undefined) {
        for (let i = 0; i < this.state.ipLog.ipList.length; i++) {
          ipItems.push(
            <li key={i}>
              {this.state.ipLog.ipList[i].ip} -{" "}
              {this.state.ipLog.ipList[i].timeStamp}
            </li>
          );
        }
      }

      const ipAdminItems = [];
      if (this.state.ipLog.adminList !== undefined) {
        for (let i = 0; i < this.state.ipLog.adminList.length; i++) {
          ipAdminItems.push(
            <li key={i}>
              {this.state.ipLog.adminList[i].ip} -{" "}
              {this.state.ipLog.adminList[i].timeStamp}
            </li>
          );
        }
      }

      return (
        <div className="SignupList">
          <br />
          <br />
          <center>
            {" "}
            <h1>SuperAdmin</h1>
          </center>
          <center>
            {" "}
            <p>
              ADVARSEL: Denne siden er kun til bruk for superbrukere. <br />{" "}
              Feil bruk av denne siden kan føre til kritiske feil, og tap av
              data
            </p>
            {this.state.ipLog.unique !== undefined && (
              <div className="card">
                <h3>LOG</h3>
                <br />
                <h5>Unique visitors: {this.state.ipLog.unique}</h5>

                <hr />

                <h3>Last 5 unique IPs</h3>
                <br />
                <center>
                  {" "}
                  <ul className="noBullet">{ipItems}</ul>
                </center>
                <hr />
                <h3>ADMIN</h3>
                <br />
                <h5>Unique Admins: {this.state.ipLog.AdminUnique}</h5>
                <hr />
                <h3>Last 5 Admin IPs</h3>
                <br />
                <center>
                  {" "}
                  <ul className="noBullet">{ipAdminItems}</ul>
                </center>
              </div>
            )}
            <br />
            <button onClick={this.purgeLAN}>Reset LAN</button>
            <button onClick={this.remakeSeats}>Sett opp plasser</button>
            <button onClick={this.createDevCopy}>Lag ny dev kopi</button>
            <button onClick={this.restoreBackup}>
              Gjenopprett db fra backup
            </button>
          </center>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/Admin/SuperAdmin.js